import type { ObjectiveStatusName, TrafficLight } from '@fluxus/shared';

/** Situação do objetivo como selo (cor + ícone + texto) — a mesma na lista e no detalhe. */
export const OBJECTIVE_STATUS_LIGHT: Record<ObjectiveStatusName, TrafficLight> = {
  PLANNED: 'gray',
  IN_PROGRESS: 'blue',
  AT_RISK: 'yellow',
  DONE: 'green',
  SUSPENDED: 'gray',
};
